import { motion } from "framer-motion";
import { Smartphone, Monitor, Laptop, TabletSmartphone } from "lucide-react";

export const ServicesShowcase = () => {
  const services = [
    {
      icon: Monitor,
      title: "Web Design",
      features: ["Responsive Layouts", "Interactive Elements", "Visual Hierarchy", "Micro-interactions"]
    },
    {
      icon: Smartphone,
      title: "Mobile Design",
      features: ["Native Patterns", "Touch Interactions", "Gesture Controls", "App Flow"]
    },
    {
      icon: Laptop,
      title: "Product Design",
      features: ["User Research", "Wireframing", "Prototyping", "Testing"]
    },
    {
      icon: TabletSmartphone,
      title: "Design Systems",
      features: ["Component Library", "Style Guide", "Documentation", "Maintenance"]
    }
  ];

  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4">Our Services</h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto">
            Comprehensive design solutions for every digital touchpoint
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-800 to-blue-600 rounded-xl transform group-hover:scale-105 transition-transform duration-300" />
              <div className="relative p-6 border border-blue-700 rounded-xl backdrop-blur-sm">
                <div className="mb-6">
                  <service.icon className="h-12 w-12 text-blue-200" />
                </div>
                <h3 className="text-2xl font-semibold mb-4">{service.title}</h3>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="text-blue-200 flex items-center">
                      <span className="w-2 h-2 bg-blue-400 rounded-full mr-2" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};